import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService {
  readonly name = '@apexdesigner/optimatch';
  readonly version = '0.2.0';
  readonly description = '';
  readonly displayName = 'OptiMatch';
}
